import { render } from "./ItemReport.vue?vue&type=template&id=2c59040c"
import script from "./ItemReport.vue?vue&type=script&lang=js"
export * from "./ItemReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__